module.exports = __webpack_public_path__ + "static/media/banner_header_muertos.8093737b.svg";